import type { FaireProductEntity } from "../../entity_types/product";

export const p_85zuvdfqvw: FaireProductEntity = {
  token: "p_85zuvdfqvw",
  type: "product",
  name: "Éclaire 18K Gold Non-Tarnish CZ Station Chain Necklace",
  brandToken: "b_3tzh9mjdm6",
  brandName: "Flânerie by MAIQ",
  imageUrl:
    "https://cdn.faire.com/fastly/901b0337adafd499848b0b8a2add37f659b8c26260baa9f6ffa9cf47994f5ce0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/27eca9cc6b3b5b48480e708e3ed0540840325ed68982e11790a7d7b17a0969b8.jpeg",
    "https://cdn.faire.com/fastly/a1a09a58d271413bb8169382c58a2774bdb6ee634be98edc7b63dfa6afc1dc08.jpeg",
    "https://cdn.faire.com/fastly/3e219988e9e6e6d66b998ef6716cadf07c179cb338569f14cb7692e276d39584.jpeg",
  ],
  priceDollars: 8.9,
  description:
    "18K Gold Non-Tarnish CZ Station Chain Necklace\n18K Gold Plating\nStainless Steel\nCubic Zirconia\nPendant Size (inch): 0.19\nChain Length (inch): 15.74\nExtension(inch): 2\n \n- Lead-free, Nickel-safe\n- Hypoallergenic\n- Water Resistant",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:15.258Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
